import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'

export const useCountries = () => {
  const { i18n } = useTranslation()

  const countries = useMemo(() => {
    const i18nTrans = {
      'en-US': 'en',
      'pt-BR': 'pt-br',
      'es-ES': 'es',
      ch: 'ch'
    }
    console.log('i18n.language', i18n.language)
    const language = i18nTrans[i18n.language] || 'pt-br'
    try {
      // Importa dinamicamente o arquivo countries.json baseado no idioma atual
      const countriesData = require(`i18n/locales/${language}/countries.json`)

      // Converte o objeto em array no formato { title, value }
      return Object.entries(countriesData).map(([value, title]) => ({
        title: title as string,
        value
      }))
    } catch (error) {
      console.warn(
        `Não foi possível carregar países para o idioma ${language}`,
        error
      )

      // Fallback para português se não encontrar o arquivo
      try {
        const fallbackData = require('../i18n/locales/pt-br/countries.json')
        return Object.entries(fallbackData).map(([value, title]) => ({
          title: title as string,
          value
        }))
      } catch (fallbackError) {
        console.error('Erro ao carregar países do fallback', fallbackError)
        return []
      }
    }
  }, [i18n.language])

  return countries
}
